let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aaNAu")).then(() => parcelRequire('8NXtU'));